import { Text } from "@mantine/core";
import { useBlocker } from "@tanstack/react-router";

import { ConfirmModal } from "../ui/ConfirmModal";

/**
 * Live's prompt before unsaved changes are left (`components/navigation-prompt`, spec A3d): while
 * `when` holds, a navigation in the app asks "Leave without saving?", and Stay, the close button,
 * Escape or a click outside keep the page. As live's, it never asks on a reload or a closed tab.
 * A page's own navigation after a save or a delete passes by with `ignoreBlocker`.
 */
export function LeaveGuard({ when }: { when: boolean }) {
  const leaving = useBlocker({
    shouldBlockFn: () => when,
    // The router asks on every reload while a blocker that allows it is mounted.
    enableBeforeUnload: false,
    withResolver: true,
  });
  return (
    <ConfirmModal
      opened={leaving.status === "blocked"}
      title="Leave without saving?"
      cancelLabel="Stay"
      confirmLabel="Leave"
      confirm="primary"
      onConfirm={() => leaving.proceed?.()}
      onCancel={() => leaving.reset?.()}
    >
      <Text>Your changes aren’t saved yet. Unsaved data or uploads will be lost if you leave.</Text>
    </ConfirmModal>
  );
}
